// extracted by mini-css-extract-plugin
module.exports = {"title":"XdiAttribution_title__1Ayu8","logo":"XdiAttribution_logo__o8n66"};